import React from "react";
import AddBlogs from "../../Administrative/AddBlogs";

const AddYuvasarthiBlogs = () => {
  return (
    <div>
      <AddBlogs role="Super Admin" />
    </div>
  );
};

export default AddYuvasarthiBlogs;
